import { Module } from "wrapper6";

var $ = jQuery;

export default class PostLoop extends Module {

	ready(app) {

        this.LOADER = $('#loader-overlay');

        this.DESTINATION = $('.mtt-post-loop__inner');
        this.PAGINATION = '#post-pagination li a';
        this.PAGINATION_DEST = $('#post-pagination');

        this.post_type = '';
        this.card_type = '';
        this.page_number = 0;

        // Click on pagination
         $(document).on('click', this.PAGINATION, (e) => {

            this.post_type = $('.mtt-post-loop').attr('data-id');
            this.card_type = $('.mtt-post-loop').attr('data-card');
                                    
			// Prevent default link behavior
			e.preventDefault();

			// Update page number
            this.page_number = $(e.target).attr('data-page');

			// Run ajax request
            this.getPosts();

		});

    }

    getPosts() {
        // Show loader
        this.LOADER.addClass('show');		

        // Set ajax data
        let data = {
            'action': 'filter_posts',
            'page_number': this.page_number,
            'post_type': this.post_type,
            'card_type': this.card_type,
            'url': window.location.href,
        };
        
        // Ajax call
        jQuery.post(main_theme_objects.ajax_url, data, (response) => {	                            

            if (response != 0) {
                                
                // Post response
                if (response.markup !== "") {                    
                    this.DESTINATION.html(response.markup);                    
                    this.DESTINATION.append('<div class="loop-filler"> </div>');
                    this.DESTINATION.append('<div class="loop-filler"> </div>');
                } else {
                    this.DESTINATION.html('<p class="no-posts">Der er desværre ingen indlæg der opnår disse kriterier</p>');
                }

                // Pagination response
                this.PAGINATION_DEST.html(response.pagination);
                
                // Hide loader
                this.LOADER.removeClass('show');

            }
        });
}
}